export default __webpack_public_path__ + "static/media/edit_historical_talent_status.5feb6099.svg";